import {
    scholarshipStubZenith200,
    scholarshipStubHyperion200,
    scholarshipStubZenith150,
    fullScholarshipStub,
    cumulativeScholarshipStub200,
    cumulativeScholarshipStub400,
    cumulativeFullScholarshipStub,
} from 'Scholarship';
import { oneTimePlan, annualPlan, monthlyPlan, fullScholarshipPlan, monthlyExtendedPlan } from 'TuitionPlan';
import { ProgramType } from 'Program';
import { type CohortForAdminListsAttrs, type CohortSection, CohortSectionType } from '../CohortAttrs.types';
import { type CohortForAdminListsResponse } from '../CohortIndex.types';
import { type Cohort } from '../Cohort.types';

export const globalCohortSection: CohortSection = {
    id: 'bec89df2-c25d-4484-8684-d7b4d78196c8',
    identifier: 'global',
    sectionType: CohortSectionType.Default,
};

export const regionalCohortSection: CohortSection = {
    id: '689ff015-0566-45bd-b8d5-32cf12db4aa8',
    identifier: 's_se_asia',
    sectionType: CohortSectionType.Regional,
};

const oneDay = 24 * 60 * 60;
const startDate = 1660550400;
export const mockCohortForAdminLists: CohortForAdminListsAttrs = {
    id: '813c1e36-f454-4da4-b3dd-ea5b635a81bf',
    name: 'EMBA46',
    programType: ProgramType.emba,
    startDate,
    endDate: 1695628800,
    startOfAdmissionCycle: startDate - oneDay * 90,
    studentNetworkActivationDate: startDate - oneDay * 14,
    graduationDate: startDate + oneDay * 390,
    isolatedNetwork: false,
    graduationDaysOffsetFromEnd: 14,
    cohortSections: [globalCohortSection, regionalCohortSection],
    slackRooms: [
        {
            id: '204b7bf8-706b-47e2-9121-530f83112421',
            name: 'slackRoom',
            title: 'Slack Room',
        },
    ],
    availableScholarshipIds: [
        scholarshipStubZenith200.id,
        scholarshipStubHyperion200.id,
        scholarshipStubZenith150.id,
        fullScholarshipStub.id,
        cumulativeScholarshipStub200.id,
        cumulativeScholarshipStub400.id,
        cumulativeFullScholarshipStub.id,
    ],
    availableTuitionPlanIds: [
        fullScholarshipPlan.id,
        oneTimePlan.id,
        annualPlan.id,
        monthlyPlan.id,
        monthlyExtendedPlan.id,
    ],
    selectableAvailableTuitionPlanFrequencies: [
        oneTimePlan.frequency,
        annualPlan.frequency,
        monthlyPlan.frequency,
        monthlyExtendedPlan.frequency,
    ],
    tuitionPlanFrequenciesSelectableByDefault: [oneTimePlan.frequency, annualPlan.frequency, monthlyPlan.frequency],
};

export const mockCohortsForAdminLists: CohortForAdminListsAttrs[] = [
    {
        ...mockCohortForAdminLists,
        id: 'a774cc08-4481-4f8b-8753-0e0f236e29a5',
        programType: ProgramType.emba,
        name: 'EMBA46',
    },
    {
        ...mockCohortForAdminLists,
        id: '8020e996-0fda-4adb-8442-51a15a460e17',
        programType: ProgramType.emba,
        name: 'EMBA47',
    },
    {
        ...mockCohortForAdminLists,
        id: 'f573dd78-8590-4f2b-873b-624f131e08b4',
        programType: ProgramType.mba,
        name: 'MBA46',
    },
    {
        ...mockCohortForAdminLists,
        id: '0968d0e4-55fd-465f-9390-cb6902f515d5',
        programType: ProgramType.mba,
        name: 'MBA47',
    },
    {
        ...mockCohortForAdminLists,
        id: '0e375858-0905-4a31-8062-f9f3ea4a00a0',
        programType: ProgramType.mba,
        name: 'MBA48',
    },
    {
        ...mockCohortForAdminLists,
        id: '76e980de-ea16-49e6-9fc3-86595475aa8f',
        programType: ProgramType.mba,
        name: 'MBA49',
    },
    {
        ...mockCohortForAdminLists,
        id: '23e2092b-8c56-4768-99ef-64397c08885b',
        programType: ProgramType.mba,
        name: 'MBA50',
    },
    {
        ...mockCohortForAdminLists,
        id: '22df65d6-ea58-4a90-af7c-d9b8bb596a27',
        programType: ProgramType.mba,
        startDate: 1694419200,
        name: 'MBA55',
    },
    {
        ...mockCohortForAdminLists,
        id: '75b11ebe-89d9-4c47-a2dd-107f957a03ba',
        programType: ProgramType.emba,
        name: 'EMBA44',
    },
    {
        ...mockCohortForAdminLists,
        id: 'fae31afc-aa93-4f95-8cf2-71a172db8163',
        programType: ProgramType.emba,
        name: 'EMBA50',
    },
    {
        ...mockCohortForAdminLists,
        id: 'a6c885f3-2e71-4450-9819-cb2cc1b917a6',
        programType: ProgramType.emba,
        name: 'EMBA48',
    },
    {
        ...mockCohortForAdminLists,
        id: 'ce962a61-8dd4-4f61-8724-67109ecf6acc',
        programType: ProgramType.mba_leadership,
        name: 'MBALM51',
    },
    {
        ...mockCohortForAdminLists,
        id: 'b107d463-c9f8-447c-bea6-2e5e4017af00',
        programType: ProgramType.mba_leadership,
        name: 'MBALM52',
    },
    {
        ...mockCohortForAdminLists,
        id: '167db581-8d04-4a3d-a1a1-2869145aa292',
        programType: ProgramType.mba_leadership,
        name: 'MBALM53',
    },
    {
        ...mockCohortForAdminLists,
        id: '8c364ef6-391a-46b0-8c04-140fed06fc0d',
        programType: ProgramType.mba_leadership,
        name: 'MBALM54',
    },
    {
        ...mockCohortForAdminLists,
        id: '3d94c488-54e9-47df-853e-545c227e48dc',
        programType: ProgramType.emba_strategic_leadership,
        name: 'EMBASL46',
    },
    {
        ...mockCohortForAdminLists,
        id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
        programType: ProgramType.msse,
        name: 'MSSE46',
    },
    {
        ...mockCohortForAdminLists,
        id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
        programType: ProgramType.msse,
        name: 'MSSE47',
    },
];

export const mockGetCohortsForAdminApiResponse: CohortForAdminListsResponse = {
    contents: {
        cohorts: mockCohortsForAdminLists,
    },
};

// oxlint-disable-next-line max-lines-per-function
export function getStubCohort(overrides: Partial<Cohort> = {}): Cohort {
    return {
        id: 'cohort-id',
        name: 'cohort-name',
        title: 'cohort-title',
        completionDeadline: 1672549200,
        versionId: 'cohort-version-id',
        currentPeriodIndex: -1,
        playlistCollections: [
            {
                title: '',
                requiredPlaylistPackIds: ['foundations-playlist-pack-id', 'required-playlist-pack-id'],
            },
        ],
        specializationPlaylistPackIds: ['specialization-playlist-pack-id'],
        supportsFoundationsPlaylist: true,
        foundationsPlaylistLocalePack: {
            id: 'foundations-playlist-pack-id',
            contentItems: [
                {
                    locale: 'en',
                    title: 'title',
                },
            ],
        },
        foundationsLessonStreamLocalePackIds: ['foundations-stream-pack-id'],
        cohortSections: [globalCohortSection],
        slackRooms: [],
        idVerificationPeriods: [
            {
                dueDateDaysOffset: 49,
                startDateDaysOffset: 42,
            },
        ],
        startDate: 1672549200,
        endDate: 1672749200,
        graduationDate: 1672549200 + oneDay * 390,
        programType: ProgramType.mba,
        enrollmentDeadlineDaysOffset: 0,
        streamLocalePacksInfo: {},
        periods: [],
        learnerProjects: [],
        projectUnlockData: [],
        registrationDeadlineDaysOffset: 0,
        applicationDeadline: 1662549200,
        admissionRounds: [{ applicationDeadlineDaysOffset: -80, decisionDateDaysOffset: 0 }],
        availableTuitionPlanIds: ['tuition-plan-id'],
        avgNumAssessmentsPerSpecialization: 1,
        avgNumExamsPerSpecialization: 1,
        numRequiredSpecializations: 3,
        courseSummary: { id: '123', fileFileName: 'test-file.pdf', url: 'http://google.com' },
        providesStudentNetworkAccess: true,
        programGuideUrl: 'http://google.com',
        externalScheduleUrl: 'http://google.com',
        ...overrides,
    };
}
